<template>
	<div class="container" :style="$store.state.equipment.height">
		<div class="content">
			<img src="@/assets/image/batchSignUp/submit_success.png" alt="">
			<h2>提交成功!</h2>
			<span>提交成功！等待评价方审核...</span>
			<el-row width="100%" justify="space-around">
				<el-button type="primary" plain @click="returnIndex">返回首页</el-button>
				<el-button type="primary" @click="checkOrder">查看订单</el-button>
			</el-row>
		</div>
	</div>
</template>
<script>

export default {
	computed: {
		payType: function() {
			return this.$route.params.payType === 'bankCard'
		}
	},
	methods: {
		returnIndex: function() {
			this.$router.push('/index')
		},
		checkOrder: function() {
			this.$router.push('/order/list')
		}
	}
}
</script>
<style scoped lang='less'>
.container {
	background: #F1F1F1;
}
.content{
	width: 100%;
	height: 40%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: white;
	padding-top: 70px;
	img{
		width: 160px;
		height: 160px;
	}
	h2{ 
		margin-top: 20px;
		font-size: 32px;
		font-weight: bold;
	}
	span {
		margin: 20px 0 60px 0;
		font-size: 26px;
		color: #909399;
	}
}
</style>